import React, { FC, memo } from 'react';
import { IBranchOrderTypeOption } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';

interface IProps {
  option: IBranchOrderTypeOption;
  error?: boolean;
  onClick: (id: string | number) => void;
}

const OrderTypeCheckboxOption: FC<IProps> = ({ option, error, onClick }): JSX.Element => {
  return (
    <Checkbox
      value={option.status}
      name={option.id}
      label={option.type}
      error={error}
      labelClassName="family-medium text-size-16"
      onClick={onClick}
    />
  );
};

export default memo(OrderTypeCheckboxOption);
